import Stack from "@mui/material/Stack";
import RegistryPhaseInfo from "./RegistryPhaseInfo";
import { useTranslation } from "react-i18next";
import Hidden from "@mui/material/Hidden";
import Grid from "@mui/material/Grid";
import { useFormContext } from "react-hook-form";
import { useEffect, useState } from "react";
import { CBRegistryPhase, IFormValues } from "../../types";

const RegistryPhaseDetails = () => {

    const { t } = useTranslation("customerbase");
    const { getValues } = useFormContext<IFormValues>();

    const [orderedPhases, setOrderedPhases] = useState<CBRegistryPhase[]>([]);

    useEffect(() => {
        const arr = getValues("cbRegistryPhases");

        if(!!arr) setOrderedPhases(arr?.sort((a,b) => {return a.phaseType > b.phaseType ? -1 : a.phaseType < b.phaseType ? 1 : 0}));

    }, [getValues("cbRegistryPhases")]);

    return (
        <>
            <Hidden lgDown>
                <Stack direction="row" columnGap={2}>
                    {     
                        orderedPhases?.map((phase) => (
                            <RegistryPhaseInfo
                                key={`lgDown-phase-icon-${phase.phaseType?.toLowerCase()}`}
                                title={t(`labels.${phase.phaseType}`)}
                               phase={phase}
                            />
                        ))        
                    }
                </Stack>
            </Hidden>
            <Hidden lgUp>
                <Grid item container md={6} xs={12} flexWrap={"nowrap"} mt={1}>
                    <Stack direction="row" columnGap={2}>
                        {
                            orderedPhases?.map((phase) => (
                                <RegistryPhaseInfo
                                    key={`lgUp-phase-icon-${phase.phaseType?.toLowerCase()}`}
                                    title={t(`labels.${phase.phaseType}`)}
                                    phase={phase}
                                />
                            ))   
                        }
                    </Stack>
                </Grid>
            </Hidden>
        </>
    )

}

export default RegistryPhaseDetails;